// 261030 S12h — «Làm lại từ bước X» (kiểu Sky: duyệt xong là chốt). THUẦN (không import antd).
// BE ghi `status.gates.<STEP>.redo` CHỈ khi NGƯỜI sửa dữ liệu của bước đã duyệt; cổng vẫn «đã duyệt», các bước sau vẫn chạy với bản đã chốt. Việc máy làm không bao giờ sinh dấu này.
export type RedoStep = 'STEP1' | 'ASSETS' | 'BOARD';
export interface RedoMark { from: RedoStep; at: string; source: string }
export interface RedoGatesLike { STEP1?: { redo?: RedoMark | null } | null; ASSETS?: { redo?: RedoMark | null } | null; BOARD?: { redo?: RedoMark | null } | null }

const STEP_NUMBER: Record<RedoStep, string> = { STEP1: '①', ASSETS: '②', BOARD: '③' };
const STEP_NAME: Record<RedoStep, string> = { STEP1: 'Kịch bản', ASSETS: 'Tài sản', BOARD: 'Sơ đồ + Storyboard' };
const NEXT_NOTE: Record<RedoStep, string> = {
  STEP1: 'Máy tạo lại phần ảnh bước ② bị ảnh hưởng (hộp xác nhận nêu số ảnh và tiền).',
  ASSETS: 'Máy vẽ lại sơ đồ / storyboard bị ảnh hưởng ở bước ③ (hộp xác nhận nêu số ảnh và tiền).',
  BOARD: 'Máy viết lại prompt ở bước ④ cho phần bị ảnh hưởng (hộp xác nhận nêu số video và tiền).',
};

/** Dấu «làm lại» của một bước; vắng / không hợp lệ ⇒ null. */
export function redoOf(gates: RedoGatesLike | null | undefined, step: RedoStep): RedoMark | null {
  const m = gates?.[step]?.redo;
  return m && typeof m === 'object' && typeof m.at === 'string' ? { from: step, at: m.at, source: String(m.source ?? '') } : null;
}
export const redoLabelOf = (step: RedoStep): string => `Làm lại từ bước ${STEP_NUMBER[step]}`;
/** Nội dung băng «Bạn đã sửa bước X sau khi duyệt». Cổng vẫn đã duyệt; không tự chạy lại gì. */
export function redoBannerOf(step: RedoStep): { message: string; description: string; button: string } {
  return {
    message: `Bạn đã sửa bước ${STEP_NUMBER[step]} (${STEP_NAME[step]}) sau khi duyệt`,
    description: `Cổng vẫn giữ «đã duyệt» và các bước sau vẫn chạy với bản đã chốt — không bị kéo về. Muốn các bước sau theo thay đổi này thì bấm «${redoLabelOf(step)}». ${NEXT_NOTE[step]}`,
    button: redoLabelOf(step),
  };
}
